const palette = {
  primary: {
    main: "#00624F",
    light: "#A8DDD6",
    dark: "#004734",
    900: "#004734",
    800: "#00624F",
    700: "#00725E",
    600: "#00826D",
    500: "#008F79",
    400: "#00A08D",
    300: "#21B1A0",
    200: "#6BC8BC",
    100: "#A8DDD6",
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore overriding with errors on purpose
    75: "#CAEDE7",
    50: "#EDF8F7",
    25: "#F4FFFE",
    10: "#F8FCFC"
  },
  secondary: {
    main: "#C34700",
    light: "#F5B699",
    dark: "#AB3A00",
    900: "#AB3A00",
    800: "#C34700",
    700: "#D04E00",
    600: "#DD5500",
    500: "#E75B00",
    400: "#EB712F",
    300: "#EE8956",
    200: "#F3A987",
    100: "#F5B699",
    50: "#FFDABE",
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore overriding with errors on purpose
    25: "#FFF7F0"
  },
  highlight1: {
    main: "#00588F",
    light: "#B9D7E7",
    dark: "#003D75",
    900: "#003D75",
    800: "#00588F",
    700: "#0D689F",
    600: "#1E79B0",
    500: "#2985BB",
    400: "#5195BF",
    300: "#6BA6C8",
    200: "#90BFD8",
    100: "#B9D7E7",
    50: "#E3EFF5",
    contrastText: "000"
  },
  highlight2: {
    main: "#3C429B",
    light: "#CACFEC",
    dark: "#2F2F86",
    900: "#2F2F86",
    800: "#3C429B",
    700: "#434CA7",
    600: "#4C56B4",
    500: "#525FBE",
    400: "#6B77C8",
    300: "#8591D2",
    200: "#A8B0DF",
    100: "#CACFEC",
    50: "#EAECF7",
    contrastText: "000"
  },
  highlight3: {
    main: "#6D209A",
    light: "#E2BFE7",
    dark: "#4E188C",
    900: "#4E188C",
    800: "#6D209A",
    700: "#7E24A2",
    600: "#9029AA",
    500: "#9E2DB0",
    400: "#AD4BBC",
    300: "#BC6BC8",
    200: "#CF95D8",
    100: "#E2BFE7",
    50: "#F3E5F5",
    contrastText: "000"
  },
  grey: {
    900: "#212121",
    800: "#424242",
    700: "#616161",
    600: "#757575",
    500: "#9E9E9E",
    400: "#BDBDBD",
    300: "#E0E0E0",
    200: "#EEEEEE",
    100: "#F5F5F5",
    50: "#FAFAFA"
  },
  error: {
    main: "#A91B34",
    light: "#F0C9D2",
    dark: "#9B0B29",
    900: "#9B0B29",
    800: "#A91B34",
    700: "#B5223B",
    600: "#C72B42",
    500: "#D63245",
    400: "#D04A5B",
    300: "#C86B77",
    200: "#D9939C",
    100: "#F0C9D2",
    50: "#FEF1F3"
  },
  warning: {
    main: "#B26800",
    light: "#FFDA99",
    dark: "#472A00",
    900: "#472A00",
    800: "#B26800",
    700: "#CC7700",
    600: "#E58900",
    500: "#F99806",
    400: "#F9A21F",
    300: "#FAAC38",
    200: "#FFC266",
    100: "#FFDA99",
    50: "#FFF9E5"
  },
  success: {
    main: "#007E3C",
    light: "#C0E7CD",
    dark: "#005E28",
    900: "#005E28",
    800: "#007E3C",
    700: "#008F47",
    600: "#02A153",
    500: "#10B05D",
    400: "#46BC75",
    300: "#6BC88D",
    200: "#98D7AD",
    100: "#C0E7CD",
    50: "#E8FDEE"
  }
};
export {
  palette
};
